import { Component, OnInit, Output, TemplateRef, ViewChild, EventEmitter, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { BanqueService } from '../../../../services/Banque/banque.service';
import { BankAccount, Banque, BanqueResponse } from '../../../../models/banque.model';
import { environment } from '../../../../../environments/environment';
interface ExtendedBankAccount extends BankAccount {
}

@Component({
  selector: 'app-croud-compte-bancaire',
  templateUrl: './croud-compte-bancaire.component.html',
  styleUrls: ['./croud-compte-bancaire.component.scss']
})
export class CroudCompteBancaireComponent implements OnInit {
  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  @Output() close = new EventEmitter<void>();
  @Output() accountAdded = new EventEmitter<ExtendedBankAccount>();
  @Output() accountUpdated = new EventEmitter<ExtendedBankAccount>();
  @Input() idStation!: number;
  file:string=environment.file_url;
  private stationIdFromStorage: number = 0;
  private clientIdFromStorage: number = 0;
  modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
  private modalRef: NgbModalRef | null = null;
  isLoading: boolean = false;
  bankData: ExtendedBankAccount = {
    id: null,
    client_id: 0,
    station_id: 0,
    nom: '',
    swift: '',
    designation: '',
    agence: '',
    rib: '',
    logo: '',
    date_update: '',
    statut: true
  };
  allBanks: Banque[] = [];
  confirmationMessage: string | null = null;
  newStatut: boolean | null = null; 

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private banqueService: BanqueService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
    this.loadAllBanks();
  }

  /**
   * Charge les données utilisateur depuis localStorage
   * et récupère l'ID de la station et du client
   */
  private loadUserData(): void {
    try {
      const userJson = localStorage.getItem('currentUser');
      if (userJson) {
        const user = JSON.parse(userJson);
        const station = user?.stations?.[0];
        this.stationIdFromStorage = station?.id ? Number(station.id) : 0;
        this.clientIdFromStorage = user?.id ? Number(user.id) : 0;
        console.log('📋 [CroudCompteBancaireComponent] Station ID chargé depuis localStorage:', this.stationIdFromStorage);
        console.log('📋 [CroudCompteBancaireComponent] Client ID chargé depuis localStorage:', this.clientIdFromStorage);
        
        // Si idStation n'est pas défini via @Input, utiliser celui du localStorage
        if (!this.idStation && this.stationIdFromStorage) {
          this.idStation = this.stationIdFromStorage;
        }
      }
    } catch (error) {
      console.error('❌ [CroudCompteBancaireComponent] Erreur lors de la récupération des données utilisateur:', error);
    }
  }

  loadAllBanks(): void {
    this.isLoading = true;
    console.log('Calling getAllBanques...');
    this.banqueService.getAllBanques().subscribe({
      next: (response: BanqueResponse) => {
        console.log('API Response:', response);
        this.allBanks = response.banques || [];
        console.log('allBanks after update:', this.allBanks);
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading all banks:', err);
        this.toastr.error('Erreur lors du chargement des banques: ' + (err.message || 'Erreur inconnue'), 'Erreur');
        this.isLoading = false;
      }
    });
  }

  openModal(type: 'ajouter' | 'update' | 'etat', data?: any, idStation?: number, message?: string): void {
    this.modalType = type;
    this.resetForm();
    console.log('Opening modal with type:', this.modalType, 'and data:', data);

    // Charger les données utilisateur si pas encore chargées
    if (!this.stationIdFromStorage) {
      this.loadUserData();
    }

    // Prioriser l'ID passé en paramètre, sinon utiliser celui du localStorage
    if (idStation) {
      this.idStation = idStation;
    } else if (this.stationIdFromStorage && !this.idStation) {
      this.idStation = this.stationIdFromStorage;
    }

    console.log('📋 [CroudCompteBancaireComponent] ID Station utilisé:', this.idStation);

    if (type === 'update' || type === 'etat') {
      this.bankData = { ...data, id: data.id || null, statut: data.statut !== undefined ? data.statut : true };
      if (type === 'etat') {
        this.newStatut = !this.bankData.statut; 
      }
    }

    if (type === 'etat' && message) {
      this.confirmationMessage = message; 
    } else {
      this.confirmationMessage = null; 
    }

    const options: NgbModalOptions = {
      size: 'lg',
      centered: true,
      backdrop: true,
      keyboard: true
    };
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.modalRef = this.modalService.open(this.modalTemplate, options);
    this.modalRef.result.then(
      () => this.closeModal(),
      () => this.closeModal()
    );
  }

  resetForm(): void {
    this.bankData = {
      id: null,
      client_id: 0,
      station_id: 0,
      nom: '',
      swift: '',
      designation: '',
      agence: '',
      rib: '',
      logo: '',
      date_update: '',
      statut: true
    };
    this.newStatut = null;
  }

  cancelModal(): void {
    console.log('Canceling modal');
    this.toastr.info('Action annulée', 'Information');
    this.isLoading = false;
    if (this.modalRef) {
      this.modalRef.dismiss('Cancel click');
    }
  }

  closeModal() {
    console.log('Closing modal with type:', this.modalType);
    this.close.emit();
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }

  onSubmit(form: NgForm) {
    // Vérifier et charger l'ID de station si nécessaire
    if (!this.idStation) {
      if (!this.stationIdFromStorage) {
        this.loadUserData();
      }
      if (this.stationIdFromStorage) {
        this.idStation = this.stationIdFromStorage;
      }
    }

    if (!this.idStation) {
      console.error('❌ [CroudCompteBancaireComponent] ID de station non disponible');
      this.toastr.error('ID de station non disponible. Veuillez vous reconnecter.', 'Erreur');
      return;
    }

    console.log('✅ [CroudCompteBancaireComponent] ID Station pour la soumission:', this.idStation);

    if (this.modalType === 'etat' && this.bankData.id !== null) {
      this.isLoading = true;
      const account: Banque = { 
        ...this.bankData, 
        id: this.bankData.id,
        statut: this.newStatut !== null ? this.newStatut : this.bankData.statut 
      };
      this.banqueService.updateBanque(this.idStation, this.bankData.id, account).subscribe({
        next: (response) => {
          this.accountUpdated.emit(response);
          const message = this.confirmationMessage || 'Opération';
          this.toastr.success(`${message} réussie`, 'Succès');
          this.closeModal();
          this.isLoading = false;
        },
        error: (err) => {
          console.error('Error updating state:', err);
          const message = this.confirmationMessage || 'l\'opération';
          this.toastr.error(`Erreur lors de ${message.toLowerCase()}.`, 'Erreur');
          this.isLoading = false;
        }
      });
    } else if (form.valid || (this.modalType === 'ajouter' || this.modalType === 'update')) {
      this.isLoading = true;
      const account = { ...this.bankData };
     
      if (this.modalType === 'update' && this.bankData.id !== null) {
        account.date_update = new Date().toISOString();
      }
      if (this.modalType === 'ajouter') {
        // S'assurer que client_id et station_id sont récupérés depuis localStorage
        if (!this.clientIdFromStorage) {
          this.loadUserData();
        }
        if (!this.stationIdFromStorage && !this.idStation) {
          this.loadUserData();
          if (this.stationIdFromStorage) {
            this.idStation = this.stationIdFromStorage;
          }
        }
        
        // Pour l'ajout, on peut utiliser account tel quel car id sera null
        const accountToAdd: Banque = {
          id: 0, // L'API générera l'ID
          client_id: this.clientIdFromStorage || account.client_id || 0, // Utiliser client_id depuis localStorage
          station_id: this.idStation, // Utiliser l'ID de station récupéré
          nom: account.nom,
          swift: account.swift || null,
          designation: account.designation || null,
          agence: account.agence || null,
          rib: account.rib,
          logo: account.logo || '',
          date_update: account.date_update || new Date().toISOString(),
          statut: account.statut
        };
        console.log('📋 [CroudCompteBancaireComponent] Ajout compte avec station_id:', accountToAdd.station_id, 'et client_id:', accountToAdd.client_id);
        this.banqueService.addBanque(this.idStation, accountToAdd).subscribe({
          next: (newAccount) => {
            this.accountAdded.emit(newAccount);
            this.toastr.success('Compte ajouté avec succès', 'Succès');
            this.closeModal();
            this.isLoading = false;
          },
          error: (err) => {
            console.error('Error adding account:', err);
            this.toastr.error('Erreur lors de l\'ajout du compte.', 'Erreur');
            this.isLoading = false;
          }
        });
      } else if (this.modalType === 'update' && this.bankData.id !== null) {
        // S'assurer que client_id et station_id sont récupérés depuis localStorage
        if (!this.clientIdFromStorage) {
          this.loadUserData();
        }
        if (!this.stationIdFromStorage && !this.idStation) {
          this.loadUserData();
          if (this.stationIdFromStorage) {
            this.idStation = this.stationIdFromStorage;
          }
        }
        
        const accountToUpdate: Banque = {
          id: this.bankData.id,
          client_id: this.clientIdFromStorage || account.client_id || 0, // Utiliser client_id depuis localStorage
          station_id: this.idStation || account.station_id, // Utiliser station_id depuis localStorage
          nom: account.nom,
          swift: account.swift || null,
          designation: account.designation || null,
          agence: account.agence || null,
          rib: account.rib,
          logo: account.logo || '',
          date_update: account.date_update || '',
          statut: account.statut
        };
        console.log('📋 [CroudCompteBancaireComponent] Mise à jour compte avec station_id:', accountToUpdate.station_id, 'et client_id:', accountToUpdate.client_id);
        this.banqueService.updateBanque(this.idStation, this.bankData.id, accountToUpdate).subscribe({
          next: (updatedAccount) => {
            this.accountUpdated.emit(updatedAccount);
            this.toastr.success('Compte mis à jour avec succès', 'Succès');
            this.closeModal();
            this.isLoading = false;
          },
          error: (err) => {
            console.error('Error updating account:', err);
            this.toastr.error('Erreur lors de la mise à jour du compte.', 'Erreur');
            this.isLoading = false;
          }
        });
      }
    }
  }
}
